module.exports = __webpack_public_path__ + "img/artboard3.4d17c481.png";